import { defaultErrorHandler as commonErrorHandler, createHeaders, getApiUrls } from './serviceConfig';

export function createUserDataService(config = {}) {
  const defaultErrorHandler = config.onError || ((error) => commonErrorHandler('User Data service', error));

  const getCoursesToc = async () => {
    try {
      const urls = getApiUrls();
      const response = await fetch(urls.userData.coursesToc(), {
        method: 'GET',
        headers: createHeaders(),
      });
      if (!response.ok) {
        throw new Error(`Failed to get courses TOC: ${response.status}`);
      }
      const data = await response.json();
      return data?.courses || [];
    } catch (error) {
      defaultErrorHandler(error);
      throw error;
    }
  };

  const getCourses = async () => {
    try {
      const urls = getApiUrls();
      const response = await fetch(urls.userData.courses(), {
        method: 'GET',
        headers: createHeaders(),
      });
      if (!response.ok) {
        throw new Error(`Failed to get user courses: ${response.status}`);
      }
      const data = await response.json();
      return data?.courses || [];
    } catch (error) {
      defaultErrorHandler(error);
      throw error;
    }
  };

  const getCoursesPractice = async () => {
    try {
      const urls = getApiUrls();
      const response = await fetch(urls.userData.coursesPractice(), {
        method: 'GET',
        headers: createHeaders(),
      });
      if (!response.ok) {
        throw new Error(`Failed to get practice courses: ${response.status}`);
      }
      const data = await response.json();
      return data?.courses ?? [];
    } catch (error) {
      defaultErrorHandler(error);
      throw error;
    }
  };

  return { getCourses, getCoursesPractice, getCoursesToc };
}

export default createUserDataService();
